import styled from "styled-components";
import {IconButton, Paper} from "@mui/material";

export const ImageWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 0 0 15px 0;
`;

export const StyledPaper = styled.div`
  padding: 40px;
  text-align: center;
  background: white;
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.2);
`;

export const IconButtonWrapper = styled.div`
  background-color: lightgrey;
  border-radius: 5px;
  width: 120px;
  height: 120px;
  justify-content: center;
  align-items: center;
  display: flex;
  &:hover {
    background-color: #f5f5f5;
  }
`;

export const ImageIconButton = styled.div`
  margin: 5px;
  font-size: 28px;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  color: #8c8c8c;

  &:hover {
    background: none;
  }
`;
